/* MÄNNERSTIMME™ · SAT Akademie · Interaktives Deck
 * Quelle: Originalfolien Nenad Vladović
 * Stand: 4 Folien · weitere folgen */
export const maennerstimmeSlides = [
  {
    num: 1,
    type: "cover",
    title: "MÄNNERSTIMME™",
    subtitle:
      "In der Kraft der Selbstverantwortung zur Männlichkeit in Würde, Klarheit und Integrität.",
    intro:
      "Die Männerstimme™ Initiative der SAT Akademie für Transformation begleitet Männer auf ihrem Weg zu bewusster Männlichkeit, innerer Führung und echter Verantwortung.",
    pillars: [
      { h: "SELBSTVERANTWORTUNG", t: "Übernehme die Verantwortung für dein Leben und deine Entscheidungen." },
      { h: "INTEGRITÄT", t: "Lebe deine Werte. Sei authentisch. Sei verlässlich." },
      { h: "INNERE STÄRKE", t: "Entfalte deine Kraft aus Klarheit, Disziplin und Selbstführung." },
      { h: "EMOTIONALE REIFE", t: "Fühle bewusst. Drücke aus. Bleibe in Verbindung." },
      { h: "KLARE AUSRICHTUNG", t: "Kenn deine Vision. Setze Ziele. Gehe deinen Weg." },
      { h: "VERMÄCHTNIS", t: "Sei Vorbild. Präge deine Generation. Hinterlasse Spuren." },
    ],
    tagline: "HERZ · VERSTAND · SEELE · KRAFT",
    closing: "Wir stärken Männer. Für mich. Für andere. Für die Zukunft.",
  },

  {
    num: 2,
    type: "content",
    layout: "grid",
    kicker: "WARUM MÄNNERSTIMME™?",
    title: "Die Welt braucht keine lauten Männer. Sie braucht bewusste Männer.",
    subtitle:
      "Männer stehen heute vor einer Zeitenwende. Alte Rollenbilder greifen nicht mehr. Die Anforderungen sind komplexer. Der Druck ist größer. Die Orientierung fehlt.",
    intro: "Männerstimme™ gibt dir Richtung, Stärke und Klarheit.",
    bullets: [
      { h: "Orientierung", t: "Finde Klarheit in einer komplexen Welt und deine innere Richtung." },
      { h: "Selbstverantwortung", t: "Übernimm Verantwortung für dein Leben, deine Entscheidungen und deine Wirkung." },
      { h: "Innere Stärke", t: "Stärke entsteht nicht durch Härte, sondern durch Bewusstsein, Disziplin und Charakter." },
      { h: "Authentische Männlichkeit", t: "Sei du selbst — echt, integriert und in deiner vollen Kraft." },
      { h: "Beziehungen", t: "Baue tiefe Verbindungen zu dir selbst, zu anderen und zu deiner Familie." },
      { h: "Vermächtnis", t: "Hinterlasse Spuren, die bleiben. Sei Vorbild. Präge Generationen." },
    ],
    mantra:
      "Ein bewusster Mann wartet nicht auf die Zukunft — er gestaltet sie. Für sich. Für andere. Für die Welt.",
    closing: "Du bist mehr als deine Vergangenheit. Du bist der Schöpfer deiner Zukunft.",
  },

  {
    num: 3,
    type: "content",
    layout: "grid",
    kicker: "DIE ROLLE DES MANNES",
    title: "Ein Mann ist mehr als eine Rolle.",
    subtitle:
      "Er ist ein Gestalter, ein Beschützer, ein Vorbild und ein Führer — zuerst für sich selbst.",
    intro:
      "Die Welt braucht Männer, die in ihrer Kraft stehen und bewusst handeln. Männer, die Verantwortung übernehmen, statt zu warten. Männer, die Werte leben, statt nur darüber zu sprechen. Männerstimme™ erinnert dich an das, was wirklich zählt.",
    bullets: [
      {
        h: "Führer deiner selbst",
        items: ["Kenne dich.", "Stärke deinen Geist.", "Meistere deine Emotionen.", "Handle bewusst."],
      },
      {
        h: "Vorbild & Präsenz",
        items: ["Deine Kinder brauchen dich.", "Deine Haltung prägt.", "Dein Leben lehrt mehr als deine Worte."],
      },
      {
        h: "Beschützer & Versorger",
        items: ["Schütze, was dir wichtig ist.", "Sorge für Sicherheit und Stabilität.", "Handle verlässlich."],
      },
      {
        h: "Gestalter & Entscheider",
        items: ["Triff klare Entscheidungen.", "Übernimm Verantwortung.", "Gestalte deine Welt aktiv mit."],
      },
      {
        h: "Bruder & Verbündeter",
        items: ["Stärke andere Männer.", "Baue echte Verbindungen.", "Gemeinsam sind wir stärker."],
      },
      {
        h: "Hüter von Werten & Erbe",
        items: ["Lebenswerte weitergeben.", "Traditionen bewahren.", "Ein Vermächtnis hinterlassen, auf das du stolz bist."],
      },
    ],
    mantra:
      "Ein Mann wird nicht durch das, was er hat, sondern durch das, was er gibt, und durch das, wofür er steht.",
    closing: "Deine Rolle beginnt jetzt. Nicht morgen. Sei der Mann, den die Welt braucht. Sei du.",
  },

  {
    num: 4,
    type: "content",
    layout: "grid",
    kicker: "DIE HERAUSFORDERUNGEN MODERNER MÄNNER",
    title: "Die Welt verändert sich rasant — und viele Männer fühlen sich verunsichert.",
    subtitle: "Überfordert oder orientierungslos.",
    intro: "Männerstimme™ hilft dir, Klarheit zu finden und in deiner Kraft zu stehen.",
    bullets: [
      { h: "Orientierungslosigkeit", t: "Alte Rollenbilder greifen nicht mehr. Klare Vorstellungen für die Zukunft fehlen." },
      { h: "Leistungsdruck", t: "Ständiger Druck, funktionieren zu müssen — im Beruf, in der Familie, im Leben. Erschöpfung statt Erfüllung." },
      { h: "Emotionale Distanz", t: "Viele Männer wurden nicht gelehrt, über Gefühle zu sprechen — und leiden still im Inneren." },
      { h: "Verlust von Verbindung", t: "Zu sich selbst, zur Partnerin, zu den Kindern, zu Freunden — echte Verbindung geht verloren." },
      { h: "Sinnfragen", t: "Wofür bin ich da? Was ist mein Beitrag? Was bleibt von mir, wenn ich gehe?" },
      { h: "Fehlende Vorbilder", t: "Viele Männer hatten keine bewussten Vorbilder — und suchen ihren eigenen Weg im Dunkeln." },
    ],
    mantra:
      "Die größte Krise eines Mannes ist nicht, dass er zu schwach ist, sondern dass er vergessen hat, wer er ist.",
    cta: {
      title: "Du musst diesen Weg nicht allein gehen",
      sub: "Gemeinsam stärken wir Männer — für uns, für unsere Familien, für die Welt.",
    },
  },
  {
    num: 5,
    type: "content",
    layout: "grid",
    kicker: "DER SAT ANSATZ — KLARHEIT · VERANTWORTUNG · WIRKUNG",
    title: "Herz. Verstand. Seele. Kraft.",
    subtitle:
      "Männerstimme™ basiert auf dem bewährten SAT Transformationsmodell. Wir verbinden Bewusstseinsarbeit, emotionale Intelligenz, körperliche Stärke und gelebte Werte zu echter Veränderung — innen wie außen.",
    intro: "Unser Ansatz ist ganzheitlich. Praktisch. Tiefgehend. Umsetzbar.",
    bullets: [
      { h: "Bewusstsein", t: "Erkenne dich selbst. Verstehe deine Muster, Glaubenssätze und Emotionen. Nur was du verstehst, kannst du verändern." },
      { h: "Klarheit", t: "Finde deine Vision, deine Werte und deinen Lebensauftrag. Klare Ziele geben deinem Leben Richtung und Fokus." },
      { h: "Selbstdisziplin", t: "Werde der Mann, der tut, was wichtig ist — nicht nur, was leicht ist. Disziplin ist die Brücke zwischen Ziel und Ergebnis." },
      { h: "Emotionale Stärke", t: "Lerne, deine Emotionen zu verstehen, zu steuern und als Kraft zu nutzen — für dich und deine Beziehungen." },
      { h: "Verbundenheit", t: "Echte Stärke entsteht im Miteinander. Brüderschaft, Vertrauen und Austausch machen dich und uns alle stärker." },
      { h: "Wirkung", t: "Setze dein Potenzial ein, hinterlasse Spuren und gestalte eine bessere Zukunft — für deine Familie und die Welt." },
    ],
    mantra: "Veränderung beginnt nicht im Außen. Sie beginnt mit der Entscheidung, wer du sein willst.",
    cta: {
      title: "Dies ist kein Theorieprogramm",
      sub: "Das ist ein Weg der Umsetzung, der dich formt — Schritt für Schritt — zu dem Mann, der du sein willst.",
    },
  },

  {
    num: 6,
    type: "content",
    layout: "grid",
    kicker: "UNSERE METHODEN — ECHT · TIEF · WIRKSAM",
    title: "Erleben. Verstehen. Verändern.",
    subtitle:
      "Veränderung braucht mehr als Wissen. Sie braucht Erfahrung. Deshalb arbeiten wir mit bewährten, tiefgreifenden Methoden, die Kopf, Herz und Körper verbinden.",
    intro: "Unsere Kernmethoden für echte Transformation.",
    bullets: [
      {
        h: "Ziel & Werte Klärung",
        items: ["Klarheit über deine Vision", "Deine Lebensziele", "Deine Kernwerte", "Dein Lebensauftrag"],
      },
      {
        h: "Selbstreflexion & Bewusstsein",
        items: ["Tiefe Selbsterkenntnis", "Muster erkennen", "Glaubenssätze lösen", "In die Eigenverantwortung kommen"],
      },
      {
        h: "Mentale Stärke & Fokus",
        items: ["Gedanken steuern", "Disziplin aufbauen", "Fokus trainieren", "Durchhaltevermögen stärken"],
      },
      {
        h: "Emotionale Intelligenz",
        items: ["Gefühle verstehen", "Emotional reif sein", "Beziehungen vertiefen", "Emotional führen"],
      },
      {
        h: "Körper & Energie-Management",
        items: ["Körper als Fundament", "Energie steigern", "Resilienz aufbauen", "Performance entfalten"],
      },
      {
        h: "Umsetzung & Verankerung",
        items: ["Konkrete Schritte gehen", "Gewohnheiten etablieren", "Dranbleiben", "Nachhaltig leben"],
      },
    ],
    mantra:
      "Methoden sind Werkzeuge. Doch deine Bereitschaft ist der Schlüssel. Der Einsatz ist dein Weg. Die Transformation ist dein Ergebnis.",
    cta: {
      title: "Methoden geben dir den Rahmen",
      sub: "Deine Entscheidung gibt dir die Kraft. Dein Handeln schafft dein neues Leben.",
    },
  },

  {
    num: 7,
    type: "content",
    layout: "grid",
    kicker: "FÜR WEN IST MÄNNERSTIMME™?",
    title: "Für Männer, die mehr wollen.",
    subtitle:
      "Nicht mehr leisten — sondern mehr leben. Nicht mehr funktionieren — sondern echt sein.",
    intro: "Für Männer in jeder Lebensphase. Wir begleiten dich, wenn du …",
    bullets: [
      {
        h: "Am Anfang deines Weges stehst",
        items: [
          "Du suchst Orientierung, Identität und Klarheit.",
          "Du willst wissen, wer du wirklich bist.",
          "Du willst wachsen und deinen Platz finden.",
        ],
      },
      {
        h: "Mittendrin Verantwortung trägst",
        items: [
          "Du führst — im Beruf, in der Familie, im Leben.",
          "Du willst bewusster entscheiden und handeln.",
          "Du suchst Balance zwischen Leistung und Lebensqualität.",
        ],
      },
      {
        h: "Vater bist oder es werden willst",
        items: [
          "Du möchtest ein Vorbild sein, das bleibt.",
          "Du willst eine echte Verbindung zu deinen Kindern aufbauen.",
          "Du willst Werte weitergeben, nicht nur Worte.",
        ],
      },
      {
        h: "Einen Neuanfang wagst",
        items: [
          "Du spürst, dass es Zeit für Veränderung ist.",
          "Du willst los, was dich klein macht oder zurückhält.",
          "Du willst neu ausrichten — bewusst und mutig.",
        ],
      },
      {
        h: "Mehr Tiefe und Erfüllung suchst",
        items: [
          "Oberflächlichkeit erfüllt dich nicht mehr.",
          "Du suchst Sinn, Verbindung und Wahrheit.",
          "Du willst innerlich wachsen und reifen.",
        ],
      },
      {
        h: "Die Welt mitgestalten willst",
        items: [
          "Du willst einen positiven Beitrag leisten.",
          "Du setzt dich für Werte ein, die bleiben.",
          "Du willst Spuren hinterlassen, die Bedeutung haben.",
        ],
      },
    ],
    mantra:
      "Nicht jeder Mann ist laut. Aber jeder Mann kann Wirkung haben. Finde deinen Weg. Sei du.",
    cta: {
      title: "Egal, wo du stehst — du bist willkommen",
      sub: "Wichtig ist nicht, woher du kommst. Sondern wohin du gehst.",
    },
  },

  {
    num: 8,
    type: "content",
    layout: "grid",
    kicker: "DEIN VERMÄCHTNIS ALS MANN",
    title: "Was bleibt, wenn du gehst?",
    subtitle:
      "Am Ende deines Lebens zählt nicht, was du besitzt. Sondern was du bewirkt hast. Wen du geprägt hast. Welche Werte du gelebt und weitergegeben hast.",
    intro:
      "Männerstimme™ hilft dir, ein Vermächtnis zu hinterlassen, auf das du stolz sein kannst — und das bleibt.",
    bullets: [
      { h: "Dein Charakter", t: "Integrität, Ehrlichkeit und Verlässlichkeit — das Fundament deines Vermächtnisses." },
      { h: "Deine Familie", t: "Die Liebe, Präsenz und Führung, die deine Familie stark macht — generationenübergreifend." },
      { h: "Deine Werte", t: "Die Prinzipien, für die du stehst und lebst — sie werden weiterwirken, wenn du nicht mehr da bist." },
      { h: "Deine Inspiration", t: "Die Menschen, die du ermutigst und befähigst, ihren eigenen Weg zu gehen." },
      { h: "Deine Taten", t: "Nicht die großen Worte, sondern die konsequenten Handlungen machen den Unterschied." },
      { h: "Deine Spuren", t: "Unsichtbar, aber spürbar. Dein Einfluss bleibt — in Herzen, Leben und in der Welt." },
    ],
    mantra:
      "Ein Mann hinterlässt Spuren — nicht im Sand, sondern im Leben anderer Menschen.",
    cta: {
      title: "Baue heute, was morgen Bestand hat",
      sub: "Sei der Mann, an den man sich erinnert — mit Respekt, Dankbarkeit und Liebe.",
    },
  },
  {
    num: 9,
    type: "content",
    layout: "grid",
    kicker: "DEIN ERBE BEGINNT MIT DEINER ENTSCHEIDUNG",
    title: "Du musst nicht perfekt sein, um zu beginnen.",
    subtitle:
      "Aber du musst beginnen, um nicht ein Leben zu verpassen, das in dir darauf wartet, gelebt zu werden.",
    intro: "Die Entscheidung liegt bei dir. Jeden Tag. In jedem Moment.",
    bullets: [
      {
        h: "Morgenritual",
        items: ["5 Minuten Stille", "Dankbarkeit", "Tagesintention setzen"],
      },
      {
        h: "Körper & Energie",
        items: ["Bewege dich täglich", "Iss bewusst", "Schlafe ausreichend"],
      },
      {
        h: "Mentale Stärke",
        items: ["Lerne täglich", "Fokus halten", "Negative Gedanken hinterfragen"],
      },
      {
        h: "Beziehungen",
        items: ["Sei präsent", "Höre zu", "Zeige Wertschätzung"],
      },
      {
        h: "Fokus & Handlung",
        items: ["Plane deinen Tag", "Setze Prioritäten", "Handle konsequent"],
      },
      {
        h: "Beitrag & Erbe",
        items: ["Hilf anderen", "Teile dein Wissen", "Baue etwas auf, das bleibt"],
      },
    ],
    mantra:
      "Das Vermächtnis eines Mannes wird nicht daran gemessen, wie laut er gewesen ist, sondern wie tief er gewirkt hat.",
    cta: {
      title: "Du bist nicht hier, um durchschnittlich zu sein",
      sub: "Du bist hier, um zu transformieren — dich selbst und die Welt.",
    },
  },

  {
    num: 10,
    type: "content",
    layout: "grid",
    kicker: "2 IN 1 — DEIN WEG · DEINE TRANSFORMATION™",
    title: "Wissen ist Potenzial. Umsetzung ist Macht.",
    subtitle:
      "Männerstimme™ ist mehr als ein Programm. Es ist dein 2 in 1 — Wissen & Umsetzung. Wir geben dir das Wissen, die Werkzeuge und die Gemeinschaft. Doch die Umsetzung — die liegt bei dir.",
    intro: "Du bist der Architekt deines Lebens. Wir geben dir den Bauplan. Du baust dein Meisterwerk.",
    bullets: [
      {
        h: "Wissen erhalten",
        items: ["Fundiertes Wissen", "Praxisnahe Tools", "Erprobte Methoden", "Klarheit gewinnen"],
      },
      {
        h: "Umsetzung entscheiden",
        items: ["Nicht wissen, sondern tun", "Tägliche kleine Entscheidungen", "Große Wirkung"],
      },
      {
        h: "Dranbleiben & Wachsen",
        items: ["Disziplin schlägt Motivation", "Routinen aufbauen", "Stetig besser werden"],
      },
      {
        h: "Gemeinschaft erleben",
        items: ["Gleichgesinnte Männer", "Unterstützung", "Austausch", "Gemeinsam wachsen"],
      },
      {
        h: "Transformation leben",
        items: ["Neue Identität", "Neue Gewohnheiten", "Neue Ergebnisse", "Neues Leben"],
      },
      {
        h: "Dein Erbe schaffen",
        items: ["Werte weitergeben", "Andere inspirieren", "Spuren hinterlassen", "Für die Zukunft"],
      },
    ],
    mantra:
      "Die einzige Grenze für deinen Weg ist die Entscheidung, die du heute triffst. Und die triffst nur du.",
    cta: {
      title: "Deine Entscheidung. Dein Weg. Dein Leben.",
      sub: "Wissen ist Potenzial. Umsetzung ist Macht. Heute beginnt — deine Transformation.",
    },
    footerStrip: [
      { h: "Herz fühlen", t: "Mit Empathie." },
      { h: "Verstand denken", t: "Mit Klarheit." },
      { h: "Seele verbinden", t: "Mit Sinn." },
      { h: "Kraft handeln", t: "Mit Disziplin." },
      { h: "Für dich · Für andere", t: "Für die Welt." },
    ],
  },

  {
    num: 11,
    type: "content",
    layout: "grid",
    kicker: "DEIN LEBEN · DEINE VERANTWORTUNG",
    title: "Niemand wird kommen, um dein Leben für dich zu leben.",
    subtitle:
      "Du bist der Architekt. Du bist der Entscheider. Du bist der Macher. Übernimm die volle Verantwortung — für deinen Weg, deine Entscheidungen, deine Taten und deine Zukunft.",
    intro: "Männerstimme™ bedeutet: Ich wähle. Ich handle. Ich stehe dafür ein.",
    bullets: [
      {
        h: "Klare Wahlen",
        items: ["Triff bewusste Entscheidungen", "Übernimm deine Wahl", "Stehe zu deinem Weg"],
      },
      {
        h: "Volle Verantwortung",
        items: ["Schiebe nichts ab", "Keine Ausreden", "Kein Opferdenken"],
      },
      {
        h: "Konsequentes Handeln",
        items: ["Handle jeden Tag", "Bleib dran", "Bringe Dinge zu Ende"],
      },
      {
        h: "Wachstum durch Herausforderung",
        items: ["Nutze Hindernisse", "Lerne aus allem", "Werde stärker"],
      },
      {
        h: "Dienst & Beitrag",
        items: ["Gib der Welt etwas", "Beitrag statt Verbrauch", "Lebe mit Sinn"],
      },
      {
        h: "Vermächtnis schaffen",
        items: ["Baue etwas Bleibendes", "Inspiriere andere", "Hinterlasse Spuren"],
      },
    ],
    mantra:
      "Verantwortung ist nicht schwer. Sie ist befreiend. Denn sie gibt dir die Macht, dein Leben zu gestalten.",
    cta: {
      title: "Dein Leben ist dein Meisterwerk",
      sub: "Lebe es mit Stolz. Verantwortung. Und Männerstimme™.",
    },
  },

  {
    num: 12,
    type: "content",
    layout: "grid",
    kicker: "MÄNNERSTIMME™ — DEIN WEG · DEIN WIRKEN · DEIN ERBE",
    title: "Die Männerstimme™ ist mehr als ein Programm.",
    subtitle:
      "Sie ist ein Ruf. Ein Weg der Transformation. Eine Bewegung von Männern, die Verantwortung übernehmen — für sich, ihre Familie, ihre Werte und die Welt.",
    intro: "Gemeinsam verändern wir, was möglich ist.",
    bullets: [
      { h: "Orientiere dich", t: "Reflektiere, wo du stehst. Was sind deine Werte? Was ist dir wirklich wichtig?" },
      { h: "Entscheide dich", t: "Entscheide dich bewusst für den Weg der Männerstimme™. Für dein Wachstum. Für deine Verantwortung." },
      { h: "Verpflichte dich", t: "Gib dir selbst ein Versprechen. Handle konsequent. Bleib dran — auch wenn es herausfordernd wird." },
      { h: "Verbinde dich", t: "Werde Teil einer Gemeinschaft von Männern, die wachsen und gemeinsam Wirkung entfalten." },
      { h: "Handle jetzt", t: "Warte nicht auf den perfekten Moment. Dein Leben beginnt mit der Entscheidung, heute zu handeln." },
      { h: "Lebe dein Erbe", t: "Baue etwas auf, das bleibt. Für dich. Für deine Liebsten. Für kommende Generationen." },
    ],
    mantra:
      "Ein Mann, der sich selbst meistert, wird zum Segen für andere. Sei dieser Mann.",
    cta: {
      title: "Du bist nicht allein. Du bist Teil von etwas Größerem.",
      sub: "Erhebe deine Stimme. Lebe deine Werte. Gestalte deine Zukunft. Die Zeit ist jetzt. Der Mann bist du.",
    },
  },

  {
    num: 13,
    type: "content",
    layout: "grid",
    kicker: "DIE 7 PRINZIPIEN DEINES VERMÄCHTNISSES",
    title: "Dein Erbe ist größer, als du glaubst.",
    subtitle:
      "Du lebst nicht nur für dich. Du bist Teil einer Kette von Männern, die vor dir gekommen sind. Und du bist der Anfang einer neuen Generation.",
    intro: "Was du heute lebst, prägt morgen. Männerstimme™ ist dein Vermächtnis in Bewegung.",
    bullets: [
      { h: "Integrität", t: "Halte deine Versprechen — dir selbst und anderen." },
      { h: "Verantwortung", t: "Übernimm die volle Verantwortung für dein Leben und deine Entscheidungen." },
      { h: "Ziel & Sinn", t: "Lege deine Ziele fest und handle aus einem Sinn, der größer ist als du selbst." },
      { h: "Dienst", t: "Nutze deine Stärken, um anderen zu dienen und die Welt positiv zu verändern." },
      { h: "Wachstum", t: "Entwickle dich stetig weiter — in Körper, Geist und Charakter." },
      { h: "Beständigkeit", t: "Bleib dran. Auch wenn es hart wird — gerade dann." },
      { h: "Vermächtnis", t: "Baue etwas auf, das bleibt. Sei der Mann, an den man sich erinnert." },
    ],
    mantra:
      "Ein Mann lebt nicht für sich. Er lebt für das, was bleibt, wenn er geht.",
    cta: {
      title: "Dein Leben. Deine Entscheidungen. Dein Vermächtnis.",
      sub: "Starte heute. Der Moment ist jetzt.",
    },
  },
  {
    num: 14,
    type: "content",
    layout: "grid",
    kicker: "DEIN ERBE · DEINE SPUR · DIE WELT NACH DIR",
    title: "Am Ende zählt nicht, was du hattest. Sondern was du hinterlässt.",
    subtitle:
      "Die Werte, die du gelebt hast. Die Menschen, die du inspiriert hast. Die Veränderung, die durch dich möglich wurde.",
    intro: "Männerstimme™ ist der Anfang. Dein Vermächtnis ist das Ziel.",
    bullets: [
      { h: "1 · Selbst", t: "Werde der Mann, auf den du selbst stolz bist." },
      { h: "2 · Familie", t: "Sei Gegenwart. Sei Vorbild. Sei Fels." },
      { h: "3 · Beziehungen", t: "Baue echte Verbindungen. Sei loyal. Sei verlässlich." },
      { h: "4 · Gesellschaft", t: "Gib deinen Beitrag. Heb andere. Gestalte mit." },
      { h: "5 · Zukunft", t: "Pflanze heute, was morgen Früchte trägt." },
    ],
    mantra:
      "Ein Mann hinterlässt nicht nur Erfolge, sondern Spuren in Herzen, in Generationen und in der Welt.",
    cta: {
      title: "Die Welt braucht Männer mit Herz, Verstand und Rückgrat",
      sub: "Steh auf. Lebe deinen Weg. Hinterlasse dein Erbe. Die Welt wartet nicht. Du bist der Unterschied.",
    },
  },

  {
    num: 15,
    type: "content",
    layout: "grid",
    kicker: "FINALE · DEIN WEG BEGINNT",
    title: "Die Zukunft wartet nicht.",
    subtitle:
      "Männerstimme™ ist mehr als ein Programm. Es ist eine Bewegung. Eine Rückkehr zu dem, was wirklich zählt. Für dich. Für deine Familie. Für die Welt.",
    intro: "Bist du bereit, dein Erbe zu leben?",
    bullets: [
      { h: "Klarheit", t: "Du weißt, wer du bist und wohin du willst." },
      { h: "Kraft", t: "Du handelst bewusst und stehst zu deinen Entscheidungen." },
      { h: "Stärke", t: "Du überwindest Hindernisse und wächst an jeder Herausforderung." },
      { h: "Verbindung", t: "Du baust echte Beziehungen und prägst deine Umgebung positiv." },
      { h: "Wirkung", t: "Du hinterlässt Spuren, die Generationen überdauern." },
      { h: "Beständigkeit", t: "Du bleibst dir treu, auch wenn es schwierig wird." },
      { h: "Vermächtnis", t: "Du erschaffst etwas, das bleibt — dein Erbe." },
    ],
    mantra:
      "Die stärkste Generation von Männern ist die, die sich erinnert, wer sie ist.",
    cta: {
      title: "Der Weg ist vorgezeichnet. Die Entscheidung liegt bei dir.",
      sub: "Steh auf. Erhebe deine Stimme. Lebe dein Erbe. Die Welt braucht Männer, die Verantwortung übernehmen. Sei einer von ihnen.",
    },
    closing: "Dein Nenad",
  },
];

export default maennerstimmeSlides;
